var _style, _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "21.2mm",
    height: "21.2mm",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    * {\n      stroke-width: 0px;\n    }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-362",
    x: 8.1,
    y: 9.1,
    width: 43.8,
    height: 43.8,
    rx: 10,
    ry: 10,
    transform: "translate(-13.1 30.3) rotate(-45)",
    fill: "#1d1d1b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-372",
    x: 9.7,
    y: 8.4,
    width: 40.6,
    height: 40.6,
    rx: 10,
    ry: 10,
    transform: "translate(-11.5 29.6) rotate(-45)",
    fill: "#f59e00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33,28.7l5.9-5.9c.8-.8.8-2.2,0-3s-2.2-.8-3,0l-5.9,5.9-5.9-5.9c-.8-.8-2.2-.8-3,0s-.8,2.2,0,3l5.9,5.9-5.9,5.9c-.8.8-.8,2.2,0,3s1,.6,1.5.6,1.1-.2,1.5-.6l5.9-5.9,5.9,5.9c.4.4,1,.6,1.5.6s1.1-.2,1.5-.6c.8-.8.8-2.2,0-3l-5.9-5.9Z",
    fill: "#82368c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelUpIcon);
export default __webpack_public_path__ + "static/media/CancelUpIcon.8975865fe6914c95e733032284f47ab1.svg";
export { ForwardRef as ReactComponent };